import React from 'react';
import parseUrl from 'url-parse';
import { Navigate } from 'react-router-dom';

import { useCustomTranslation, useStoreSelector } from '../../../helpers/hooks';

import OfflineCard from './OfflineCard';
import IframeCard from './IframeCard';
import InvoiceRedirect from './InvoiceRedirect';
import { ErrorBlock } from '../../Block';
import PaymentInitialization from '../../PaymentInitialization';
import { useFingerprint } from '../../../hooks';

function isOffline(url) {
  return url === 'OFFLINE';
}

const iframeExceptions = ['/result/invoice'];

function isIframe(url) {
  const localUrl = parseUrl(window.location);

  const targetUrl = parseUrl(url);

  return (
    targetUrl.hostname === localUrl.hostname &&
    iframeExceptions.every(
      (exception) => !targetUrl.pathname.endsWith(exception)
    )
  );
}

export default function PerformPayment() {
  useFingerprint();
  const { urlFor, t } = useCustomTranslation();

  const invoice = useStoreSelector((selector) => {
    try {
      return selector.getInvoice();
    } catch (e) {}
  });

  if (!invoice)
    return (
      <PaymentInitialization>
        <Navigate to={urlFor('payMethodSelector')} />
      </PaymentInitialization>
    );

  const { url, method } = invoice;

  if (isOffline(url)) {
    return <OfflineCard invoice={invoice} />;
  } else if (isIframe(url)) {
    return <IframeCard invoice={invoice} />;
  } else if (method === 'GET' || method === 'POST' || method === 'PUT') {
    return <InvoiceRedirect invoice={invoice} />;
  } else {
    return <ErrorBlock headerText={t('DefaultError')} />;
  }
}
